import service from './index';
import { ReqResPayload } from '@/pages/scheme/typing';
import {
  ChangeLocationCourseKnowImagePayload,
  InsertCourseKnowImagePayload,
  UpdateCourseKnowImagePayload,
} from '@/components/TabPaneCourse1Image/courseKnowImageTypes';

export const loginApi = (info) => service.post('sys/login', info); //登录
export const getUserInfoApi = () => service.post('sys/getMySelf'); //获取登录用户信息

//********************************* 字典API *********************************
//         special_subject_type	专题项目类型
//         stu_grade	年级
//         stu_class	班级
//         course_type	课程类型
//         semester	学期
//         course_system_type	课程体系
export const getDicValueApi = (info) =>
  service.post('sysDic/getDicValue', info);
export const getAllDicApi = (info) =>
  service.post('sysAccount/getAllDic', info);

//***************************************************************************

//********************************* 组织管理 *********************************
export const getSysCourseApi = (info) =>
  service.post('schCourse/getPage', info); //课程体系列表
export const getCollegesAndMajorApi = (info) =>
  service.post('sysDept/getAll', info); // 学院||专业
export const getTreeApi = () => service.post('sysDept/selectTree'); // 学院,专业树
export const addCollegeOrMajorApi = (info) =>
  service.post('sysDept/insert', info); // 增加 学院||专业
export const editCollegeOrMajorApi = (info) =>
  service.post('sysDept/update', info); // 修改 学院||专业
export const delCollegeOrMajorApi = (info) => service.post('sysDept/del', info); // 删除 学院||专业
export const getOneByIdApi = (info) => service.post('sysDept/getOne', info); // 查询单一 学院||专业
export const getMajorStudentApi = (info) =>
  service.post('sysDept/getMajorStudent', info); // 查询专业下学生
export const getMajorTeacherApi = (info) =>
  service.post('sysDept/getMajorTeacher', info); // 查询专业下学生
export const getSysAccountApi = (info) =>
  service.post('sysAccount/getPage', info); // 查询账号
export const addSysAccountApi = (info) =>
  service.post('sysAccount/insert', info); // 添加账号
export const updateSysAccountApi = (info) =>
  service.post('sysAccount/update', info); // 添加账号
export const delSysAccountApi = (info) => service.post('sysAccount/del', info); // 添加账号

//***************************************************************************

//********************************* 用户专业 *********************************
export const getSpecialtyList = () => service.post('sysDept/getSpecialtyList');

//********************************* 课程体系 *********************************

export const getLessonsApi = (info) => service.post('schCourse/getAll', info); //课程体系列表
export const getSchCourse = (info) => service.post('schCourse/getOne', info); //获取课程信息
export const getEditCourseListIds = () =>
  service.post('schCourse/getEditCourseListIds'); //获取当前用户具有编辑权限的课程ids
export const getMyLessonsApi = (info) =>
  service.post('schCourse/getPage', info); //课程体系列表,我有权限的
export const getLessonsByPageApi = (info) =>
  service.post('schCourse/searchCourse', info); //课程体系列表
export const getChapterBySchCourseId = (info) =>
  service.post('schCourseChapter/getPage', info); //根据课程id获取章节
export const getSchCourseKnowledgeBySchCourseChapterId = (info) =>
  service.post('schCourseKnowledge/getPage', info); //根据章节id获取知识点

export const updateCourseCoverUrl = (info) =>
  service.post('schCourse/updateCoverUrl', info); //根据章节id获取知识点

export const getSchCourseResourceBySchCourseKnowledgeId = (info) =>
  service.post('schCourseResource/getPage', info); //根据二级知识点查询资源
export const download = (key) =>
  service.get('fileStore/download?key=' + key, { responseType: 'blob' }); //下载附件

export const schCourseResourceInsert = (info) =>
  service.post('schCourseResource/insert', info); // 添加资源
export const schCourseResourceUpdate = (info) =>
  service.post('schCourseResource/update', info); // 修改资源
export const schCourseRef = (info) =>
  service.post('schCourseRef/getPage', info); // 分页-各种关系
export const schCourseRefInsert = (info) =>
  service.post('schCourseRef/insert', info); // 新增先修课程
export const schCourseRefInsertSupport = (info) =>
  service.post('schCourseRef/insertSupport', info); // 新增支撑课程
export const schCourseRefInsertKnowledgeApplyFirst = (info) =>
  service.post('schCourseRef/insertKnowledgeApplyFirst', info); // 新增 一级知识的应用于
export const schCourseRefInsertKnowledgeApplySecond = (info) =>
  service.post('schCourseRef/insertKnowledgeApplySecond', info); // 新增 二级知识的应用于
export const schCourseRefInsertKnowledgeDependsFirst = (info) =>
  service.post('schCourseRef/insertKnowledgeDependsFirst', info); // 新增 一级知识的依赖于
export const schCourseRefInsertKnowledgeDependsSecond = (info) =>
  service.post('schCourseRef/insertKnowledgeDependsSecond', info); // 新增 新增 二级知识的依赖于

export const del = (info) => service.post('schCourseRef/del', info); // 删-各种关系

export const addLessonApi = (info) => service.post('schCourse/insert', info); // 添加课程

export const updateLessonApi = (info) => service.post('schCourse/update', info); // 添加课程
export const deleteLessonApi = (info) => service.post('schCourse/del', info); // 添加课程
export const addTeachersApi = (info) =>
  service.post('schCourse/addTeacher', info); // 添加老师
export const addStudentsApi = (info) =>
  service.post('schCourse/addStudent', info); // 添加学生

export const changeLocation = (info) =>
  service.post('schCourseChapter/changeLocation', info); //

export const knowledgeChangeLocation = (info) =>
  service.post('schCourseKnowledge/changeLocation', info); //
//***************************************************************************

//********************************* 课程章节 *********************************

export const addSectionApi = (info) =>
  service.post('schCourseChapter/insert', info); //添加课程章节
export const deleteSectionApi = (info) =>
  service.post('schCourseChapter/del', info); //删除课程章节
export const editSectionApi = (info) =>
  service.post('schCourseChapter/update', info); // 修改课程章节
export const getSectionApi = (info) =>
  service.post('schCourseChapter/getPage', info); //获取章节

export const searchCourseChapter = (info) =>
  service.post('schCourse/searchCourseChapter', info); //章节列表
export const searchCourseKnowledge = (info) =>
  service.post('schCourse/searchCourseKnowledge', info); //一级知识列表
export const searchCourseKnowledgeSecond = (info) =>
  service.post('schCourse/searchCourseKnowledgeSecond', info); //二级知识列表
export const searchCourseResource = (info) =>
  service.post('schCourse/searchCourseResource', info); //资料列表
export const searchCourse = (info) =>
  service.post('schCourse/searchCourse', info); //新获取课程
export const getSectionByIdApi = (info) =>
  service.post('schCourseChapter/getOne', info); // 获取章节详情

//***************************************************************************

//********************************* 课程章节知识 *********************************

export const addKnowledgeApi = (info) =>
  service.post('schCourseKnowledge/insert', info); //添加知识
export const deleteKnowledgeApi = (info) =>
  service.post('schCourseKnowledge/del', info); //删除知识
export const editKnowledgeApi = (info) =>
  service.post('schCourseKnowledge/update', info); // 修改知识
export const getKnowledgeApi = (info) =>
  service.post('schCourseKnowledge/getPage', info); //获取知识
export const getKnowledgeByIdApi = (info) =>
  service.post('schCourseKnowledge/getOne', info); //获取知识详情

//******************************************************************************

export const getSchCourseDoc = (info) =>
  service.post('schCourseDoc/getOne', info); //获取文档信息

export const updateSchCourseDoc = (info) =>
  service.post('schCourseDoc/insertOrUpdate', info); //更新文档信息
export const getCourseCountData = (info) =>
  service.post('count/courseCount', info); // 知识相关数量
export const getUserCountData = (info) => service.post('count/userCount', info); // 用户相关数量
//********************************* 资料信息 *********************************
/*
{
  "id": 0
}
*/
export const schCourseResourceDel = (info) =>
  service.post('schCourseResource/del', info); //删除资料信息

//********************************* 字典 *********************************
// export const getKnowledgeAllApi = (info) => service.post('schCourseResource/getAll',info); // 知识字典
export const getKnowledgeAllApi = (info) =>
  service.post('schCourseKnowledge/getAll', info); // 知识字典
export const getSectionAllApi = (info) =>
  service.post('schCourseChapter/getAll', info); // 章节字典
export const getLessonAllApi = (info) => service.post('schCourse/getAll', info); // 课程字典

//**********************************知识图谱********************************************
export const getSchCourseTree = (info) =>
  service.post('schCourse/getTree', info); //知识查查首页树
export const neo4j = (info) => service.post('neo4j/search', info); // 章节字典

export const sysRoleGetAll = (info) => service.post('sysRole/getAll', info); //查询全部-角色

export const sysDicgetDicValue = (info) =>
  service.post('sysDic/getDicValue', info); //字典
export const sysGetMySelf = (info) => service.post('sys/getMySelf', info); //获取个人信息 -用户表
export const updatePassword = (info) =>
  service.post('sys/updatePassword', info); //修改密码
export const schSpecialSubject = (info) =>
  service.post('schSpecialSubject/getPage', info); //我的项目
export const schCourse = (info) => service.post('schCourse/getPage', info); //我的课程
// /api/添加专题-专题项目
export const schSpecialSubjectinsert = (info) =>
  service.post('schSpecialSubject/insert', info);

export const schSpecialSubjectdel = (info) =>
  service.post('schSpecialSubject/del', info); //删除
// /api/schSpecialSubject/getOne
// 唯一查询-专题项目
export const schSpecialSubjectGetOne = (info) =>
  service.post('schSpecialSubject/getOne', info);
// ///api/章节搜索
// export const searchCourseChapter = (info) =>
// service.post('schCourse/searchCourseChapter', info);
//一级知识 搜索
// export const searchCourseKnowledge = (info) =>
// service.post('schCourse/searchCourseKnowledge', info);
//2jischCourse/searchCourseKnowledgeSecond
// export const searchCourseKnowledgeSecond = (info) =>
// service.post('schCourse/searchCourseKnowledgeSecond', info);
// //资料schCourse/searchCourseResource
// export const searchCourseResource = (info) =>
// service.post('schCourse/searchCourseResource', info);
//添加-更新 专题内容-专题项目
export const insertUpdateContent = (info) =>
  service.post('schSpecialSubject/insertUpdateContent', info);
//修改专题项目/api/
export const schSpecialSubjectupdate = (info) =>
  service.post('schSpecialSubject/update', info);

export const neo4jSearchCourse = (info) =>
  service.post('neo4j/searchCourse', info); // 指定课程查询-查询图谱 课程下面使用

export const neo4jSearchCourseType = (info) =>
  service.post('neo4j/searchCourseType', info); // 指定课程查询-查询图谱 课程下面使用
// 全部课程的树形结构 课程-章节-知识点
export const neo4jGetAllTree = (info) => service.post('neo4j/getAllTree', info);
// 全部课程的树形结构 课程-章节-知识点
export const neo4jGetAllTree1 = (info) =>
  service.post('neo4j/getAllTree1', info);
// 全部课程的树形结构 课程-章节-知识点
export const neo4jDirectlyRelated = (info) =>
  service.post('neo4j/directlyRelated', info);
// /api/
export const updateSubjectFileName = (info) =>
  service.post('schSpecialSubject/updateSubjectFileName', info); // 指定课程查询-查询图谱 课程下面使用
export const downloadFileApi = (key) => {
  // 创建URL对象
  const url = process.env.REACT_APP_BASE_URL + 'fileStore/download?key=' + key;
  // 创建a标签
  const a = document.createElement('a');
  a.href = url;
  a.target = '_blank';
  // 触发下载
  a.click();
  // 释放内存
  URL.revokeObjectURL(url);
};

//********************************* 导入文件 start *********************************
export const importCourse = (info) => service.post('excel/importCourse', info); // 指定课程查询-查询图谱 课程下面使用
//********************************* 导入文件 end ***********************************

//********************************* 培养方案 start *********************************
// 触发-培养方案的统计
export const insertPlanStatistics = (info) =>
  service.post('planStatistics/insert', info);
// 查询培养方案任务
export const getPlanTaskStatus = (info) =>
  service.post('task/getPlanTaskStatus', info);
// 分析度 各种统计 等数据
export const getStatisticalData2 = (info) =>
  service.post('plan/statisticalData2', info);
// 统计学分课程等数据
export const getStatisticalData = (info) =>
  service.post('plan/statisticalData', info);
// 分页-培养方案
export const getPlanPage = (info) => service.post('plan/getPage', info);
// 唯一查询-培养方案
export const getOnePlan = (info) => service.post('plan/getOne', info);
// 导出-培养方案
export const exportPlan = (info) =>
  service.post('plan/export', info, { responseType: 'blob' });
// 获取目录列表-培养方案目录
export const getPlanDir = (info) => service.post('planDir/getAll', info);
// 教务处-修改方案到未提交 plan/reSubmit
export const reSubmitPlan = (info) => service.post('plan/reSubmit', info);
// 教授提交方案
export const submitPlan = (info) => service.post('plan/submit', info);
/*方案目录一.培养目标*/
// 培养方案目标(目录1) 列表
export const getPlanTarget = (info) => service.post('planTarget/getOne', info);
// 修改-培养方案目标(目录1)
export const updatePlanTarget = (info) =>
  service.post('planTarget/update', info);
// 修改单个数据-培养方案目标(目录1)
export const updateOnePlanTarget = (info) =>
  service.post('planTarget/updateOne', info);
// 添加-培养方案目标(目录1)
export const insertPlanTarget = (info) =>
  service.post('planTarget/insert', info);
// 删-培养方案目标(目录1)
export const delPlanTarget = (info) => service.post('planTarget/del', info);
// 修改-专业培养目标说明
export const updatePlanTargetDesc = (info) =>
  service.post('planTarget/updateDesc1', info);
/*培养方案毕业要求(目录2)*/
// 列表-培养方案毕业要求(目录2)
export const getPlanGraReq = (info) => service.post('planGraReq/getOne', info);
// 修改-培养方案毕业要求(目录2)
export const updatePlanGraReq = (info) =>
  service.post('planGraReq/update', info);
export const insertPlanGraReq = (info) =>
  service.post('planGraReq/insert', info);
/*方案目录三.毕业要求与培养目标支撑矩阵*/
// 唯一查询-培养方案-要求-目标(目录3)
export const getOnePlanTargetGraReq = (info: { planDirId: number }) =>
  service.post('planTargetGraReq/getOne', info);
// 修改-培养方案-要求-目标(目录3)
export const updatePlanTargetGraReq = (info) =>
  service.post('planTargetGraReq/update', info);
/*方案目录四.课程体系与毕业要求支撑矩阵*/
// 获取列表-课程体系与毕业要求
export const getPlanGraReqCourseList = (info) =>
  service.post('planGraReqCourse/getOne', info);
// 获取按钮-重置数据
export const resetPlanData = (info) =>
  service.post('planGraReqCourse/insert', info);
// 修改-课程体系与毕业要求
export const updatePlanGraReqCourse = (info: ReqResPayload[]) =>
  service.post('planGraReqCourse/update', info);
// 查询全部-课程准入(目录5)
export const getAllPlanCourseAccess = (info) =>
  service.post('planCourseAccess/getAll', info);
// 分页-课程准入(目录5)
export const getPlanCourseAccessPage = (info) =>
  service.post('planCourseAccess/getPage', info);
// 唯一查询-课程准入(目录5)
export const getOnePlanCourseAccess = (info) =>
  service.post('planCourseAccess/getOne', info);
// 添加-课程准入(目录5)
export const insertPlanCourseAccess = (info) =>
  service.post('planCourseAccess/insert', info);
// 修改-课程准入(目录5)
export const updatePlanCourseAccess = (info) =>
  service.post('planCourseAccess/update', info);
// 删-课程准入(目录5)
export const delPlanCourseAccess = (info) =>
  service.post('planCourseAccess/del', info);
// 查询-课程标准 目录5-目录6公用
export const getOnePlanCourseAccessDesc = (info) =>
  service.post('planCourseAccess/getOneDesc', info);
// 修改-课程标准 目录5-目录6公用
export const updatePlanCourseAccessDesc = (info) =>
  service.post('planCourseAccess/updateDesc', info);
// 查询全部-课程准出(目录6)
export const getAllPlanCourseExit = (info) =>
  service.post('planCourseExit/getAll', info);
// 分页-课程准出(目录6)
export const getPlanCourseExitPage = (info) =>
  service.post('planCourseExit/getPage', info);
// 唯一查询-课程准出(目录6)
export const getOnePlanCourseExit = (info) =>
  service.post('planCourseExit/getOne', info);
// 添加-课程准出(目录6)
export const insertPlanCourseExit = (info) =>
  service.post('planCourseExit/insert', info);
// 修改-课程准出(目录6)
export const updatePlanCourseExit = (info) =>
  service.post('planCourseExit/update', info);
// 删-课程准出(目录6)
export const delPlanCourseExit = (info) =>
  service.post('planCourseExit/del', info);
// 唯一查询 学制学位与辅修（目录7）
export const getOnePlanDir = (info) => service.post('planDir/getOne', info);
// 修改 学制学位与辅修（目录7）
export const updatePlanDir = (info) => service.post('planDir/update', info);
// 查询全部-指导性学习计划进程(目录8)
export const getAllPlanLearning = (info) =>
  service.post('planLearning/getAll', info);
// 分页-指导性学习计划进程(目录8)
export const getPlanLearningPage = (info) =>
  service.post('planLearning/getPage', info);
// 唯一查询-指导性学习计划进程(目录8)
export const getOnePlanLearning = (info) =>
  service.post('planLearning/getOne', info);
// 获取 planLearning/insertGet
export const getInsertPlanLearning = (info) =>
  service.post('planLearning/insertGet', info);
//新增-指导性学习计划进程(目录8)
export const insertPlanLearning = (info) =>
  service.post('planLearning/insert', info);
// 删-指导性学习计划进程(目录8)
export const delPlanLearning = (info) => service.post('planLearning/del', info);
// 修改-指导性学习计划进程(目录8)
export const updatePlanLearning = (info) =>
  service.post('planLearning/update', info);
// 查询-进程表说明
export const getOnePlanLearningDesc = (info) =>
  service.post('planLearning/getOneDesc', info);
// 修改-进程表说明
export const updatePlanLearningDesc = (info) =>
  service.post('planLearning/updateDesc', info);
// 查询全部-实践环节(目录9)
export const getAllPlanPractice = (info) =>
  service.post('planPractice/getAll', info);
// 分页-实践环节(目录9)
export const getPlanPracticePage = (info) =>
  service.post('planPractice/getPage', info);
// 唯一查询-实践环节(目录9)
export const getOnePlanPractice = (info) =>
  service.post('planPractice/getOne', info);
// 添加-实践环节(目录9)
export const insertPlanPractice = (info) =>
  service.post('planPractice/insert', info);
// 修改-实践环节(目录9)
export const updatePlanPractice = (info) =>
  service.post('planPractice/update', info);
// 删-实践环节(目录9)
export const delPlanPractice = (info) => service.post('planPractice/del', info);
// 查询全部-专业选修课设置(目录10)
export const getAllPlanElectiveCourseSetting = (info) =>
  service.post('planElectiveCourseSetting/getAll', info);
// 唯一查询-专业选修课设置(目录10)
export const getOnePlanElectiveCourseSetting = (info) =>
  service.post('planElectiveCourseSetting/getOne', info);
// 修改-专业选修课设置(目录10)
export const updatePlanElectiveCourseSetting = (info) =>
  service.post('planElectiveCourseSetting/update', info);
// 删除-专业选修课设置(目录10)
export const delPlanElectiveCourseSetting = (info) =>
  service.post('planElectiveCourseSetting/del', info);
// 新建课程-已存在的组中
export const insertPlanElectiveCourseSetting = (info) =>
  service.post('planElectiveCourseSetting/insert', info);
// 新建课程-新组
export const insertPlanElectiveCourseSetting1 = (info) =>
  service.post('planElectiveCourseSetting/insert1', info);
// 新增课程-已存在的组中
export const insertPlanElectiveCourseSetting3 = (info) =>
  service.post('planElectiveCourseSetting/insert3', info);
//新增课程-新组
export const insertPlanElectiveCourseSetting4 = (info) =>
  service.post('planElectiveCourseSetting/insert4', info);

// 统计-培养方案
export const getPlanTotal = () => service.post('plan/getTotal');

// 目录4 课程体系与毕业要求 图谱
export const neo4jDir4 = (info) => service.post('neo4j/dir4', info);

// 添加批量-课程准入(目录5)
export const planCourseAccessInsert1 = (info) =>
  service.post('planCourseAccess/insert1', info);

// 添加批量-课程准出(目录6)
export const planCourseExitInsert1 = (info) =>
  service.post('planCourseExit/insert1', info);

// 拖动-排序
export const planLearningSort = (info) =>
  service.post('planLearning/sort', info);
// 拖动-排序
export const planGraReqCourseSort = (info) =>
  service.post('planGraReqCourse/sort', info);
//********************************* 培养方案 end ***********************************

//********************************* 课程ilos start ***********************************
// 分页-课程 ilos
export const getIlosPage = (info) =>
  service.post('schCourseIlos/getPage', info);
// 唯一查询-课程 ilos
export const getOneIlos = (info) => service.post('schCourseIlos/getOne', info);
// 添加-课程 ilos
export const insertIlos = (info) => service.post('schCourseIlos/insert', info);
// 修改-课程 ilos
export const updateIlos = (info) => service.post('schCourseIlos/update', info);
// 删-课程 ilos
export const delIlos = (info) => service.post('schCourseIlos/del', info);
// 查询全部-课程 ilos
export const getAllIlos = (info) => service.post('schCourseIlos/getAll', info);
//********************************* 课程ilos end ***********************************

//********************************* 课程镜像章节知识 start ***********************************
// 查询全部树形 -课程镜像章节知识
export const getCourseKnowImageTree = (info) =>
  service.post('schCourseKnowledgeImage/getTree', info);

export const getCourseKnowledgeDeptAll = (info) =>
  service.post('schCourseKnowledgeDept/getAll', info);
// 查询列表-课程镜像章节知识
export const getCourseKnowImageList = (info) =>
  service.post('schCourseKnowledgeImage/getAll', info);
// 添加-课程镜像章节知识
export const insertCourseKnowImage = (info: InsertCourseKnowImagePayload) =>
  service.post('schCourseKnowledgeImage/insert', info);

// 删除-课程镜像章节知识
export const delSchCourseKnowledgeDept = (info) =>
  service.post('schCourseKnowledgeDept/del', info);

// 添加-更新-课程体系镜像文档
export const getOneSchCourseDocImage = (info) =>
  service.post('schCourseDocImage/getOne', info);

// 唯一查询-课程体系镜像文档
export const insertSchCourseDocImage = (info) =>
  service.post('schCourseDocImage/insert', info);

// 添加-课程镜像章节知识
export const insertSchCourseKnowledgeDept = (info) =>
  service.post('schCourseKnowledgeDept/insert', info);

// 修改-课程镜像章节知识
export const updateCourseKnowImage = (info: UpdateCourseKnowImagePayload) =>
  service.post('schCourseKnowledgeImage/update', info);
// 删除-课程镜像章节知识
export const delCourseKnowImage = (info) =>
  service.post('schCourseKnowledgeImage/del', info);
// 改变节点的位置 仅支持平级 schCourseKnowledgeImage/changeLocation
export const changeLocationCourseKnowImage = (
  info: ChangeLocationCourseKnowImagePayload
) => service.post('schCourseKnowledgeImage/changeLocation', info);
//********************************* 课程镜像章节知识 end ***********************************

//********************************* 改造后的课程和知识关系树形搜索 start ***********************************
/** 查全部专业课程的树形结构
 * @param name 课程名称
 */
export const getDeptCourseTree = (name?: string) =>
  service.post('schCourse/getDeptCourseTree', { name });
/** 查全部课程的树形结构
 * @param name 一二级知识点名称
 */
export const getAllCourseTree = (name?: string) =>
  service.post('schCourse/getAllTree', { name });
//********************************* 改造后的课程和知识关系树形搜索 end ***********************************

// 分页-相似度记录表
export const getSimilarityPage = (info) =>
  service.post('similarity/getPage', info);

// 镜像资料库
export const getResourceImageAll = (info) =>
  service.post('schCourseResourceImage/getAll', info);

// 镜像资料库
export const schCourseResourceImageInsert = (info) =>
  service.post('schCourseResourceImage/insert', info);

// 镜像资料库
export const schCourseResourceImageUpdate = (info) =>
  service.post('schCourseResourceImage/update', info);

/**
 * **********************************************************
 *
 * **********************************************************/
// 获取所有图书馆资源
export const getLibraryResourceAll = (info) =>
  service.post('libraryResource/getAll', info);

// 获取图书馆资源0
export const getLibraryResourceBySearch = (info) =>
  service.post('libraryResource/getBySearch', info);

// 获取图书馆资源1
export const getLibraryResourceList1 = (info) =>
  service.post('libraryResource/getByCourseId', info);

// 获取图书馆资源2
export const getLibraryResourceList2 = (info) =>
  service.post('libraryResource/getGraphByCourseId', info);

// 添加图书馆资源
export const libraryResourceInsert = (info) =>
  service.post('libraryResource/insert', info);

// 删除图书馆资源
export const libraryResourceDel = (info) =>
  service.post('libraryResource/del', info);

// 根据课程id获取信息中心的数据到本课程上
export const getGraphByCourseIdToCourse = (info) =>
  service.post('libraryResource/getGraphByCourseIdToCourse', info);

/**
 * **********************************************************
 * AI探索
 * **********************************************************/
// 探索回显
export const getOneAndNode = (info) =>
  service.post('explore/getOneAndNode', info);

// 添加探索(用户输入问题作为根节点)
export const exploreInsertText = (info) =>
  service.post('explore/insertText', info);

// 添加探索(课程、章节或知识作为根节点)
export const insertKnowledgeOnly = (info) =>
  service.post('explore/insertKnowledgeOnly', info);

// 分页查询
export const exploreGetPage = (info) => service.post('explore/getPage', info);

// 修改探索
export const exploreUpdate = (info) => service.post('explore/update', info);

// 保存探索
export const savePosition = (info) =>
  service.post('explore/savePosition', info);

// 清空探索
export const exploreClear = (info) => service.post('explore/clear', info);

// 删除探索
export const exploreDel = (info) => service.post('explore/del', info);

// 添加节点
export const exploreNodeInsertText = (info) =>
  service.post('exploreNode/insertText', info);

// 获取节点
export const exploreNodeGetOne = (info) =>
  service.post('exploreNode/getOne', info);

// 删除节点
export const exploreNodeDel = (info) => service.post('exploreNode/del', info);

// 八图节点
export const insertEightImage = (info) =>
  service.post('exploreNode/insertEightImage', info);

// 单图节点
export const insertPicNode = (info) =>
  service.post('exploreNode/insertPicNode', info);

// 文字生图
export const insertTextToPicNode = (info) =>
  service.post('exploreNode/insertTextToPicNode', info);

// 最近探索
export const getPageSelf = (info) => service.post('explore/getPageSelf', info);

// 热门推荐
export const getPageHot = (info) => service.post('explore/getPageHot', info);

// 热门节点
export const getPageHotKnowledgeNode = (info) =>
  service.post('explore/getPageHotKnowledgeNode', info);

// 添加深思
export const insertDeepThink = (info) =>
  service.post('exploreNode/insertDeepThink', info);

// 查询深思
export const getAllDeepThink = (info) =>
  service.post('explore/getAllDeepThink', info);

// 查询深思
export const delDeepThink = (info) =>
  service.post('exploreNode/delDeepThink', info);

// 课程推荐
export const courseRecommendations = (info) =>
  service.post('agent/courseRecommendations', info);

// 知识推荐
export const courseKnowledgeRecommendations = (info) =>
  service.post('agent/courseKnowledgeRecommendations', info);

/**
 * *************************************************************************
 * 四谱
 * *************************************************************************
 */
//添加-四谱
export const atlasInsert = (info) => service.post('atlas/insert', info);
//查询全部-四谱
export const atlasGetAll = (info) => service.post('atlas/getAll', info);
//更新-四谱
export const atlasUpdate = (info) => service.post('atlas/update', info);
//唯一查询-四谱
export const atlasGetOne = (info) => service.post('atlas/getOne', info);
//能力首页-四谱
export const atlasGetAbilityHome = (info) =>
  service.post('atlas/getAbilityHome', info);
//查询全部树形结构-四谱
export const atlasGetAtlasAll = (info) =>
  service.post('atlas/getAtlasAll', info);
//能力详情-四谱
export const atlasGetAbilityOne = (info) =>
  service.post('atlas/getAbilityOne', info);
//删-四谱
export const atlasDel = (info) => service.post('atlas/del', info);
//素养和素质首页-四谱（传type）
export const atlasGetCompetencyAndQualityHome = (info) =>
  service.post('atlas/getCompetencyAndQualityHome', info);
//删 - AtlasDetail
export const atlasDetailDel = (info) => service.post('atlasDetail/del', info);
export const atlasadd = (info) => service.post('atlas/add', info);
export const cozeWorkflowHisGetAll = (info) =>
  service.post('cozeWorkflowHis/getAll', info);
export const cozeWorkflowHisDel = (info) =>
  service.post('cozeWorkflowHis/del', info);

/**
 * *************************************************************************
 * 专业就业数据
 * *************************************************************************
 */
//获取行业图谱数据
export const houseJobGetIndustryData = (info) =>
  service.post('houseJob/getIndustryData', info);
// 获取就业率数据
export const houseJobGetEmploymentRate = (info) =>
  service.post('houseJob/getEmploymentRate', info);
// 获取升学率数据
export const houseJobGetFurtherStudyRate = (info) =>
  service.post('houseJob/getFurtherStudyRate', info);
// 获取相关数据统计
export const houseJobGetRelatedData = (info) =>
  service.post('houseJob/getRelatedData', info);
//获取行业分布分析数据
export const houseJobGetIndustryDistribution = (info) =>
  service.post('houseJob/getIndustryDistribution', info);
//获取所有年份就业率升学率变化趋势
export const houseJobGetAllYearsEmploymentAndStudyRate = (info) =>
  service.post('houseJob/getAllYearsEmploymentAndStudyRate', info);
//获取各行业就业人数变化趋势
export const houseJobGetIndustryTrend = (info) =>
  service.post('houseJob/getIndustryTrend', info);
//获取学历-行业交叉分析数据
export const houseJobGetEducationIndustryCross = (info) =>
  service.post('houseJob/getEducationIndustryCross', info);
export const houseJobGetUnitNatureDistribution = (info) =>
  service.post('houseJob/getUnitNatureDistribution', info);
export const houseJobGetPopularUnits = (info) =>
  service.post('houseJob/getPopularUnits', info);
export const houseJobGetPopularCities = (info) =>
  service.post('houseJob/getPopularCities', info);

/**
 * *************************************************************************
 * 智思体统计接口
 * *************************************************************************
 */
// 获取智思体统计数据
export const houseDataCountByZst = (info: { sysSpecialityDeptId: number }) =>
  service.post('houseData/count/countByZst', info);

/**
 * *************************************************************************
 * 智思体聊天接口
 * *************************************************************************
 */
// 创建新会话
export const aiChatInsert = (info: {
  title: string;
  type: string;
  remarks?: string;
  sysSpecialityDeptId: number;
}) => service.post('aiChat/insert', info);

// 添加对话消息
export const aiChatMsgAddModelChatMsg = (info: {
  aiChatId: number;
  text: string;
  bizType: number;
}) => service.post('aiChatMsg/addModelChatMsg', info);
